import { ItemOfferHelper } from '@additional-services/classes/item.offer.helper.class';
import { GaEventService } from '@analytics/services/ga.event.service';
import { Injectable } from '@angular/core';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { ItemOffer } from '@dgx-pr-spa/shared/util';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductDetailsService } from '@product-details/services/product-details.service';
import { OfferBackendService } from '@view-offers/services/offer-backend.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import { of } from 'rxjs';
import {
  catchError,
  filter,
  map,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import * as fromItemOffer from '../actions/item.offer.action';

@Injectable()
export class ItemOfferEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly offerBackend: OfferBackendService,
    private readonly viewOffersService: ViewOffersService,
    private readonly completeOrderService: CompleteOrderService,
    public readonly productDetailsService: ProductDetailsService,
    public readonly buildConfigService: BuildConfigService,
    public readonly gaEventService: GaEventService
  ) {}

  loadItemOffer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromItemOffer.loadItemOffer),
      withLatestFrom(
        this.viewOffersService.offers$,
        this.productDetailsService.selected$,
        this.completeOrderService.createOrderLoaded$
      ),
      filter(([, , , loaded]) => !loaded),
      filter(([, , selected]) => selected.rrp > 100),
      switchMap(([, offers, selected]) => {
        const body = new ItemOfferHelper(offers, selected).requestBody;
        const { itemCode, warranty, manufactorCode, model } = body.item;

        if (
          !offers?.offer?.upsell_flag ||
          !itemCode ||
          !warranty ||
          !manufactorCode ||
          !model
        ) {
          return of(fromItemOffer.resetItemOffer());
        }

        return this.offerBackend
          .postOffer(
            `${this.buildConfigService.config.common}/v2/item/offer`,
            body
          )
          .pipe(
            map((response) => {
              return fromItemOffer.loadItemOfferSuccess({
                payload: response as ItemOffer,
              });
            }),
            catchError((error) =>
              of(fromItemOffer.loadItemOfferFail({ payload: error }))
            )
          );
      })
    )
  );
}
